<template>
  <div>
    <mdb-modal danger size="lg" @shown="componentDidMount" :show="visible" @close="closeModal">
      <mdb-modal-header color="danger">
        <mdb-modal-title>Dispute for Order Number: {{order?order.order_number:""}}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
          <mdb-container>
            <mdb-row>
                <mdb-col>
                    <mdb-input outline type="textarea" label="Remark" :rows="5"/>
                </mdb-col>
            </mdb-row>
            <mdb-row>
              <mdb-col v-for="(image,index) in images" v-bind:key="image" col="3" class="d-flex flex-column align-items-center">
                  <img class="waves-effect img-fluid" :src="renderAttachment(image)" />
                  <mdb-btn @click="deleteAttachment(index)" color="danger" size="sm"><mdb-icon icon="times" /></mdb-btn>
              </mdb-col>
              <mdb-col col="3" class="py-2">
                  <mdb-spinner v-if="loading_upload" small />
                  <mdb-btn v-if="!loading_upload" size="sm" @click="showAttachmentUpload">
                      <mdb-icon far icon="plus-square" /> Add Attachments
                  </mdb-btn>
              </mdb-col>
            </mdb-row>
            <input multiple type="file" @change="attachmentUpload" id="document-upload" hidden />
          </mdb-container>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="loading" />
        <mdb-btn>Continue</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbContainer, mdbRow, mdbCol, 
  // mdbView,mdbMask,
  mdbInput, mdbSpinner, mdbIcon } from 'mdbvue';
  import {APP_FILE_URL} from '../js/config';
  import { fileUploadAjax } from '../js/ajax';

  export default {
    components: {
      mdbModal, mdbSpinner, mdbIcon,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter, mdbInput,
      mdbBtn,mdbContainer, mdbRow, mdbCol, 
      // mdbView,mdbMask,
    },
    props: ["visible", "close", 'order'],
    data: ()=>({
      loading:false,
      name: "",
      images: [],
      loading_upload: false
    }),
    methods: {
      closeModal(){
          this.loading=false;
          this.close();
      },
      componentDidMount(){
        console.log(this.order);
      },
      showAttachmentUpload(){
        document.getElementById("document-upload").click();
      },
      renderAttachment(image=null){
        return image?APP_FILE_URL+image:require('@/assets/picture.png');
      },
      attachmentUpload(event){
        this.loading_upload=true;
        fileUploadAjax({
            url: "admin/upload_dispute_attachments",
            data: {event: event.target.files},
            complete: ()=>this.loading_upload=false,
            success: result=>{
              this.images=this.images.concat(result.data);
            },
            isShowAlert: true
        }, this)
      },
    }
  };
</script>

<style scoped>
</style>